import { dotsGroupWarning } from '#app/assets/vectors'
import { useSignOut } from '#app/shared/hooks/useSignOut'
import { SignOutButton } from '#app/shared/pages/StatusPage/IncorrectAccountTypePage'
import type React from 'react'

export const ErrorBox: React.FC<{
  performSignOut?: () => void
}> = ({ performSignOut }) => {
  return (
    <div className="flex flex-col items-center py-10">
      <img
        src={dotsGroupWarning}
        className="mb-5 mt-10 self-center"
        alt="Error"
      />
      <h2 className="mb-4 font-urbanist text-2xl font-semibold">
        Sorry! Something went wrong
      </h2>
      <p className="mb-4 px-20 text-center font-urbanist text-base font-normal text-neutral-500">
        If refreshing the page or logging out and back in doesn't fix your issue, please contact:
      </p>
      <p className="mb-4 px-5 text-center font-urbanist text-base font-semibold text-neutral-500">
        <a href="mailto:support@truenorthfleet.com" className="hover:darkblue">
          support@truenorthfleet.com
        </a>
      </p>
      {performSignOut && <SignOutButton onClick={performSignOut} />}
    </div>
  )
}

export const ErrorBoxWithSignOut: React.FC = () => {
  const { performSignOut } = useSignOut()
  return (
    <div className="flex flex-col items-center py-10">
      <ErrorBox performSignOut={performSignOut} />
    </div>
  )
}
